var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShipping(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,80v32h304v240h-98.5c-7.1-27.5-31.9-48-61.5-48s-54.4,20.5-61.5,48H64v-80H32v112h50.5c7.1,27.5,31.9,48,61.5,48 s54.4-20.5,61.5-48h133c7.1,27.5,31.9,48,61.5,48s54.4-20.5,61.5-48H512V253.5l-1-2.5l-32-96l-3.5-11H336V80H0z M16,144v32h144v-32 H16z M336,176h116.5l27.5,82v94h-18.5c-7.1-27.5-31.9-48-61.5-48s-54.4,20.5-61.5,48H336V176z M32,208v32h96v-32H32z M144,336 c17.9,0,32,14.1,32,32s-14.1,32-32,32s-32-14.1-32-32S126.1,336,144,336z M400,336c17.9,0,32,14.1,32,32s-14.1,32-32,32 s-32-14.1-32-32S382.1,336,400,336z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipping);
export default __webpack_public_path__ + "static/media/shipping.e31f53f0.svg";
export { ForwardRef as ReactComponent };